import { Button } from '@southfields-digital/mxmz-react-ui';
import { useNavigate } from 'react-router-dom';

import styles from './RundownLocked.module.scss';

interface IRundownLockedProps {
  data: CurrentUser;
  handleTakeOver: () => void;
  handleAssistant: () => void;
}

export default function RundownLocked({
  data,
  handleTakeOver,
  handleAssistant,
}: IRundownLockedProps) {
  const navigate = useNavigate();

  return (
    <div className={styles.Container}>
      <div>
        Rundown is locked by {data.name} ({data.email})
      </div>
      <div className={styles.ActionContainer}>
        <Button variant="secondary" onClick={() => navigate(-1)}>
          Back
        </Button>
        <Button variant="danger" onClick={handleTakeOver}>
          Take Over
        </Button>
        <Button variant="primary" onClick={handleAssistant}>
          Assistant
        </Button>
      </div>
    </div>
  );
}
